import { TextAreaVariantType } from '../../../../../../components/textArea/types/textArea';
import { FONT_WEIGHT } from '../../../foundations/typography';
import { TextVariantType } from '../../text/variants';
import { TextCountVariantType } from '../../textCount/variants';
import { bottomContainerCommonStyles, containerCommonStyles, contentCommonStyles, errorContainerCommonStyles, textAreaCommonStyles, } from '../commonStyles/container';
import { clearIconCommonStyles, clearIconContainerCommonStyles, leftIconCommonStyles, leftIconContainerCommonStyles, } from '../commonStyles/icon';
import { counterCommonStyles, helpMessageCommonStyles, helpMessageErrorContainerCommonStyles, placeholderCommonStyles, titleAndAdditionalInfoContainerCommonStyles, titleCommonStyles, } from '../commonStyles/text';
export const getRegularStyles = (FOUNDATIONS, FONT) => {
    return {
        [TextAreaVariantType.REGULAR]: {
            container: {
                ...containerCommonStyles(FOUNDATIONS, FONT),
            },
            content: {
                ...contentCommonStyles(FOUNDATIONS, FONT),
                error: {
                    empty: {
                        ...contentCommonStyles(FOUNDATIONS, FONT),
                        background_color: FOUNDATIONS.color_comp_forms_input_error_empty_bg,
                        outline_color: FOUNDATIONS.color_feedback_error_border_50,
                        outline_width: FOUNDATIONS.border_100,
                    },
                    filled: {
                        ...contentCommonStyles(FOUNDATIONS, FONT),
                        background_color: FOUNDATIONS.color_comp_forms_input_error_filled_bg,
                        outline_color: FOUNDATIONS.color_feedback_error_border_50,
                        outline_width: FOUNDATIONS.border_100,
                    },
                },
                disabled: {
                    empty: {
                        ...contentCommonStyles(FOUNDATIONS, FONT),
                        background_color: FOUNDATIONS.color_accent_disabled_bg_100,
                        outline_color: FOUNDATIONS.color_accent_disabled_border_100,
                        color: FOUNDATIONS.color_accent_disabled_font_100,
                    },
                    filled: {
                        ...contentCommonStyles(FOUNDATIONS, FONT),
                        background_color: FOUNDATIONS.color_accent_disabled_bg_100,
                        outline_color: FOUNDATIONS.color_accent_disabled_border_100,
                        color: FOUNDATIONS.color_accent_disabled_font_50,
                    },
                },
            },
            titleAndAdditionalInfoContainer: {
                ...titleAndAdditionalInfoContainerCommonStyles(FOUNDATIONS, FONT),
            },
            title: {
                ...titleCommonStyles(FOUNDATIONS, FONT),
                disabled: {
                    ...titleCommonStyles(FOUNDATIONS, FONT),
                    color: FOUNDATIONS.color_accent_disabled_font_100,
                },
            },
            textArea: {
                ...textAreaCommonStyles(FOUNDATIONS, FONT),
                error: {
                    empty: {
                        ...textAreaCommonStyles(FOUNDATIONS, FONT),
                        background_color: FOUNDATIONS.color_comp_forms_input_error_empty_bg,
                    },
                    filled: {
                        ...textAreaCommonStyles(FOUNDATIONS, FONT),
                        background_color: FOUNDATIONS.color_comp_forms_input_error_filled_bg,
                    },
                },
                disabled: {
                    empty: {
                        ...textAreaCommonStyles(FOUNDATIONS, FONT),
                        background_color: FOUNDATIONS.color_accent_disabled_bg_100,
                        color: FOUNDATIONS.color_accent_disabled_font_100,
                    },
                    filled: {
                        ...textAreaCommonStyles(FOUNDATIONS, FONT),
                        background_color: FOUNDATIONS.color_accent_disabled_bg_100,
                        color: FOUNDATIONS.color_accent_disabled_font_50,
                    },
                },
                placeholder: {
                    ...placeholderCommonStyles(FOUNDATIONS, FONT),
                    disabled: {
                        ...placeholderCommonStyles(FOUNDATIONS, FONT),
                        color: FOUNDATIONS.color_accent_disabled_font_100,
                    },
                },
            },
            leftIconContainer: {
                ...leftIconContainerCommonStyles(FOUNDATIONS, FONT),
            },
            leftIcon: {
                ...leftIconCommonStyles(FOUNDATIONS, FONT),
            },
            rightIconContainer: {
                ...clearIconContainerCommonStyles(FOUNDATIONS, FONT),
            },
            rightIcon: {
                ...clearIconCommonStyles(FOUNDATIONS, FONT),
            },
            bottomContainer: {
                ...bottomContainerCommonStyles(FOUNDATIONS, FONT),
            },
            helpMessageErrorContainer: {
                ...helpMessageErrorContainerCommonStyles(FOUNDATIONS, FONT),
            },
            helpMessage: {
                ...helpMessageCommonStyles(FOUNDATIONS, FONT),
                disabled: {
                    ...helpMessageCommonStyles(FOUNDATIONS, FONT),
                    color: FOUNDATIONS.color_accent_disabled_font_100,
                },
            },
            errorContainer: {
                ...errorContainerCommonStyles(FOUNDATIONS, FONT),
            },
            errorIcon: {
                width: FOUNDATIONS.size_300,
                height: FOUNDATIONS.size_300,
                color: FOUNDATIONS.color_feedback_error_font_100,
            },
            errorMessage: {
                font_variant: TextVariantType.FONT_PARAGRAPH_200,
                font_weight: FONT_WEIGHT.font_regular,
                color: FOUNDATIONS.color_feedback_error_font_100,
            },
            counter: {
                ...counterCommonStyles(FOUNDATIONS, FONT),
                disabled: {
                    ...counterCommonStyles(FOUNDATIONS, FONT),
                    color: FOUNDATIONS.color_accent_disabled_font_100,
                },
            },
            counterLeft: {
                ...counterCommonStyles(FOUNDATIONS, FONT),
                font_weight: FONT_WEIGHT.font_bold,
                disabled: {
                    ...counterCommonStyles(FOUNDATIONS, FONT),
                    color: FOUNDATIONS.color_accent_disabled_font_50,
                },
            },
            counterRight: {
                ...counterCommonStyles(FOUNDATIONS, FONT),
                disabled: {
                    ...counterCommonStyles(FOUNDATIONS, FONT),
                    color: FOUNDATIONS.color_accent_disabled_font_50,
                },
            },
            counterVariant: TextCountVariantType.DEFAULT,
            paddingBetweenIconAndText: FOUNDATIONS.spacing_150,
            focusVisibleCustom: {
                default: {
                    outline_color: FOUNDATIONS.color_comp_forms_input_active_border,
                    outline_width: FOUNDATIONS.border_100,
                },
                error: {
                    outline_color: FOUNDATIONS.color_feedback_error_border_50,
                    outline_width: FOUNDATIONS.border_100,
                },
            },
        },
    };
};
//# sourceMappingURL=regular.js.map